[
[
"0114",
"Upplands Väsby",
"stockholms-lan"
],
[
"0115",
"Vallentuna",
"stockholms-lan"
],
[
"0117",
"Österåker",
"stockholms-lan"
],
[
"0120",
"Värmdö",
"stockholms-lan"
],
[
"0123",
"Järfälla",
"stockholms-lan"
],
[
"0125",
"Ekerö",
"stockholms-lan"
],
[
"0126",
"Huddinge",
"stockholms-lan"
],
[
"0127",
"Botkyrka",
"stockholms-lan"
],
[
"0128",
"Salem",
"stockholms-lan"
],
[
"0136",
"Haninge",
"stockholms-lan"
],
[
"0138",
"Tyresö",
"stockholms-lan"
],
[
"0139",
"Upplands-Bro",
"stockholms-lan"
],
[
"0140",
"Nykvarn",
"stockholms-lan"
],
[
"0160",
"Täby",
"stockholms-lan"
],
[
"0162",
"Danderyd",
"stockholms-lan"
],
[
"0163",
"Sollentuna",
"stockholms-lan"
],
[
"0180",
"Stockholm",
"stockholms-lan"
],
[
"0181",
"Södertälje",
"stockholms-lan"
],
[
"0182",
"Nacka",
"stockholms-lan"
],
[
"0183",
"Sundbyberg",
"stockholms-lan"
],
[
"0184",
"Solna",
"stockholms-lan"
],
[
"0186",
"Lidingö",
"stockholms-lan"
],
[
"0187",
"Vaxholm",
"stockholms-lan"
],
[
"0188",
"Norrtälje",
"stockholms-lan"
],
[
"0191",
"Sigtuna",
"stockholms-lan"
],
[
"0192",
"Nynäshamn",
"stockholms-lan"
],
[
"0305",
"Håbo",
"uppsala-lan"
],
[
"0319",
"Älvkarleby",
"uppsala-lan"
],
[
"0330",
"Knivsta",
"uppsala-lan"
],
[
"0331",
"Heby",
"uppsala-lan"
],
[
"0360",
"Tierp",
"uppsala-lan"
],
[
"0380",
"Uppsala",
"uppsala-lan"
],
[
"0381",
"Enköping",
"uppsala-lan"
],
[
"0382",
"Östhammar",
"uppsala-lan"
],
[
"0428",
"Vingåker",
"sodermanlands-lan"
],
[
"0461",
"Gnesta",
"sodermanlands-lan"
],
[
"0480",
"Nyköping",
"sodermanlands-lan"
],
[
"0481",
"Oxelösund",
"sodermanlands-lan"
],
[
"0482",
"Flen",
"sodermanlands-lan"
],
[
"0483",
"Katrineholm",
"sodermanlands-lan"
],
[
"0484",
"Eskilstuna",
"sodermanlands-lan"
],
[
"0486",
"Strängnäs",
"sodermanlands-lan"
],
[
"0488",
"Trosa",
"sodermanlands-lan"
],
[
"0509",
"Ödeshög",
"ostergotlands-lan"
],
[
"0512",
"Ydre",
"ostergotlands-lan"
],
[
"0513",
"Kinda",
"ostergotlands-lan"
],
[
"0560",
"Boxholm",
"ostergotlands-lan"
],
[
"0561",
"Åtvidaberg",
"ostergotlands-lan"
],
[
"0562",
"Finspång",
"ostergotlands-lan"
],
[
"0563",
"Valdemarsvik",
"ostergotlands-lan"
],
[
"0580",
"Linköping",
"ostergotlands-lan"
],
[
"0581",
"Norrköping",
"ostergotlands-lan"
],
[
"0582",
"Söderköping",
"ostergotlands-lan"
],
[
"0583",
"Motala",
"ostergotlands-lan"
],
[
"0584",
"Vadstena",
"ostergotlands-lan"
],
[
"0586",
"Mjölby",
"ostergotlands-lan"
],
[
"0604",
"Aneby",
"jonkopings-lan"
],
[
"0617",
"Gnosjö",
"jonkopings-lan"
],
[
"0642",
"Mullsjö",
"jonkopings-lan"
],
[
"0643",
"Habo",
"jonkopings-lan"
],
[
"0662",
"Gislaved",
"jonkopings-lan"
],
[
"0665",
"Vaggeryd",
"jonkopings-lan"
],
[
"0680",
"Jönköping",
"jonkopings-lan"
],
[
"0682",
"Nässjö",
"jonkopings-lan"
],
[
"0683",
"Värnamo",
"jonkopings-lan"
],
[
"0684",
"Sävsjö",
"jonkopings-lan"
],
[
"0685",
"Vetlanda",
"jonkopings-lan"
],
[
"0686",
"Eksjö",
"jonkopings-lan"
],
[
"0687",
"Tranås",
"jonkopings-lan"
],
[
"0760",
"Uppvidinge",
"kronobergs-lan"
],
[
"0761",
"Lessebo",
"kronobergs-lan"
],
[
"0763",
"Tingsryd",
"kronobergs-lan"
],
[
"0764",
"Alvesta",
"kronobergs-lan"
],
[
"0765",
"Älmhult",
"kronobergs-lan"
],
[
"0767",
"Markaryd",
"kronobergs-lan"
],
[
"0780",
"Växjö",
"kronobergs-lan"
],
[
"0781",
"Ljungby",
"kronobergs-lan"
],
[
"0821",
"Högsby",
"kalmar-lan"
],
[
"0834",
"Torsås",
"kalmar-lan"
],
[
"0840",
"Mörbylånga",
"kalmar-lan"
],
[
"0860",
"Hultsfred",
"kalmar-lan"
],
[
"0861",
"Mönsterås",
"kalmar-lan"
],
[
"0862",
"Emmaboda",
"kalmar-lan"
],
[
"0880",
"Kalmar",
"kalmar-lan"
],
[
"0881",
"Nybro",
"kalmar-lan"
],
[
"0882",
"Oskarshamn",
"kalmar-lan"
],
[
"0883",
"Västervik",
"kalmar-lan"
],
[
"0884",
"Vimmerby",
"kalmar-lan"
],
[
"0885",
"Borgholm",
"kalmar-lan"
],
[
"0980",
"Gotland",
"gotlands-lan"
],
[
"1060",
"Olofström",
"blekinge-lan"
],
[
"1080",
"Karlskrona",
"blekinge-lan"
],
[
"1081",
"Ronneby",
"blekinge-lan"
],
[
"1082",
"Karlshamn",
"blekinge-lan"
],
[
"1083",
"Sölvesborg",
"blekinge-lan"
],
[
"1214",
"Svalöv",
"skane-lan"
],
[
"1230",
"Staffanstorp",
"skane-lan"
],
[
"1231",
"Burlöv",
"skane-lan"
],
[
"1233",
"Vellinge",
"skane-lan"
],
[
"1256",
"Östra Göinge",
"skane-lan"
],
[
"1257",
"Örkelljunga",
"skane-lan"
],
[
"1260",
"Bjuv",
"skane-lan"
],
[
"1261",
"Kävlinge",
"skane-lan"
],
[
"1262",
"Lomma",
"skane-lan"
],
[
"1263",
"Svedala",
"skane-lan"
],
[
"1264",
"Skurup",
"skane-lan"
],
[
"1265",
"Sjöbo",
"skane-lan"
],
[
"1266",
"Hörby",
"skane-lan"
],
[
"1267",
"Höör",
"skane-lan"
],
[
"1270",
"Tomelilla",
"skane-lan"
],
[
"1272",
"Bromölla",
"skane-lan"
],
[
"1273",
"Osby",
"skane-lan"
],
[
"1275",
"Perstorp",
"skane-lan"
],
[
"1276",
"Klippan",
"skane-lan"
],
[
"1277",
"Åstorp",
"skane-lan"
],
[
"1278",
"Båstad",
"skane-lan"
],
[
"1280",
"Malmö",
"skane-lan"
],
[
"1281",
"Lund",
"skane-lan"
],
[
"1282",
"Landskrona",
"skane-lan"
],
[
"1283",
"Helsingborg",
"skane-lan"
],
[
"1284",
"Höganäs",
"skane-lan"
],
[
"1285",
"Eslöv",
"skane-lan"
],
[
"1286",
"Ystad",
"skane-lan"
],
[
"1287",
"Trelleborg",
"skane-lan"
],
[
"1290",
"Kristianstad",
"skane-lan"
],
[
"1291",
"Simrishamn",
"skane-lan"
],
[
"1292",
"Ängelholm",
"skane-lan"
],
[
"1293",
"Hässleholm",
"skane-lan"
],
[
"1315",
"Hylte",
"hallands-lan"
],
[
"1380",
"Halmstad",
"hallands-lan"
],
[
"1381",
"Laholm",
"hallands-lan"
],
[
"1382",
"Falkenberg",
"hallands-lan"
],
[
"1383",
"Varberg",
"hallands-lan"
],
[
"1384",
"Kungsbacka",
"hallands-lan"
],
[
"1401",
"Härryda",
"vastra-gotalands-lan"
],
[
"1402",
"Partille",
"vastra-gotalands-lan"
],
[
"1407",
"Öckerö",
"vastra-gotalands-lan"
],
[
"1415",
"Stenungsund",
"vastra-gotalands-lan"
],
[
"1419",
"Tjörn",
"vastra-gotalands-lan"
],
[
"1421",
"Orust",
"vastra-gotalands-lan"
],
[
"1427",
"Sotenäs",
"vastra-gotalands-lan"
],
[
"1430",
"Munkedal",
"vastra-gotalands-lan"
],
[
"1435",
"Tanum",
"vastra-gotalands-lan"
],
[
"1438",
"Dals-Ed",
"vastra-gotalands-lan"
],
[
"1439",
"Färgelanda",
"vastra-gotalands-lan"
],
[
"1440",
"Ale",
"vastra-gotalands-lan"
],
[
"1441",
"Lerum",
"vastra-gotalands-lan"
],
[
"1442",
"Vårgårda",
"vastra-gotalands-lan"
],
[
"1443",
"Bollebygd",
"vastra-gotalands-lan"
],
[
"1444",
"Grästorp",
"vastra-gotalands-lan"
],
[
"1445",
"Essunga",
"vastra-gotalands-lan"
],
[
"1446",
"Karlsborg",
"vastra-gotalands-lan"
],
[
"1447",
"Gullspång",
"vastra-gotalands-lan"
],
[
"1452",
"Tranemo",
"vastra-gotalands-lan"
],
[
"1460",
"Bengtsfors",
"vastra-gotalands-lan"
],
[
"1461",
"Mellerud",
"vastra-gotalands-lan"
],
[
"1462",
"Lilla Edet",
"vastra-gotalands-lan"
],
[
"1463",
"Mark",
"vastra-gotalands-lan"
],
[
"1465",
"Svenljunga",
"vastra-gotalands-lan"
],
[
"1466",
"Herrljunga",
"vastra-gotalands-lan"
],
[
"1470",
"Vara",
"vastra-gotalands-lan"
],
[
"1471",
"Götene",
"vastra-gotalands-lan"
],
[
"1472",
"Tibro",
"vastra-gotalands-lan"
],
[
"1473",
"Töreboda",
"vastra-gotalands-lan"
],
[
"1480",
"Göteborg",
"vastra-gotalands-lan"
],
[
"1481",
"Mölndal",
"vastra-gotalands-lan"
],
[
"1482",
"Kungälv",
"vastra-gotalands-lan"
],
[
"1484",
"Lysekil",
"vastra-gotalands-lan"
],
[
"1485",
"Uddevalla",
"vastra-gotalands-lan"
],
[
"1486",
"Strömstad",
"vastra-gotalands-lan"
],
[
"1487",
"Vänersborg",
"vastra-gotalands-lan"
],
[
"1488",
"Trollhättan",
"vastra-gotalands-lan"
],
[
"1489",
"Alingsås",
"vastra-gotalands-lan"
],
[
"1490",
"Borås",
"vastra-gotalands-lan"
],
[
"1491",
"Ulricehamn",
"vastra-gotalands-lan"
],
[
"1492",
"Åmål",
"vastra-gotalands-lan"
],
[
"1493",
"Mariestad",
"vastra-gotalands-lan"
],
[
"1494",
"Lidköping",
"vastra-gotalands-lan"
],
[
"1495",
"Skara",
"vastra-gotalands-lan"
],
[
"1496",
"Skövde",
"vastra-gotalands-lan"
],
[
"1497",
"Hjo",
"vastra-gotalands-lan"
],
[
"1498",
"Tidaholm",
"vastra-gotalands-lan"
],
[
"1499",
"Falköping",
"vastra-gotalands-lan"
],
[
"1715",
"Kil",
"varmlands-lan"
],
[
"1730",
"Eda",
"varmlands-lan"
],
[
"1737",
"Torsby",
"varmlands-lan"
],
[
"1760",
"Storfors",
"varmlands-lan"
],
[
"1761",
"Hammarö",
"varmlands-lan"
],
[
"1762",
"Munkfors",
"varmlands-lan"
],
[
"1763",
"Forshaga",
"varmlands-lan"
],
[
"1764",
"Grums",
"varmlands-lan"
],
[
"1765",
"Årjäng",
"varmlands-lan"
],
[
"1766",
"Sunne",
"varmlands-lan"
],
[
"1780",
"Karlstad",
"varmlands-lan"
],
[
"1781",
"Kristinehamn",
"varmlands-lan"
],
[
"1782",
"Filipstad",
"varmlands-lan"
],
[
"1783",
"Hagfors",
"varmlands-lan"
],
[
"1784",
"Arvika",
"varmlands-lan"
],
[
"1785",
"Säffle",
"varmlands-lan"
],
[
"1814",
"Lekeberg",
"orebro-lan"
],
[
"1860",
"Laxå",
"orebro-lan"
],
[
"1861",
"Hallsberg",
"orebro-lan"
],
[
"1862",
"Degerfors",
"orebro-lan"
],
[
"1863",
"Hällefors",
"orebro-lan"
],
[
"1864",
"Ljusnarsberg",
"orebro-lan"
],
[
"1880",
"Örebro",
"orebro-lan"
],
[
"1881",
"Kumla",
"orebro-lan"
],
[
"1882",
"Askersund",
"orebro-lan"
],
[
"1883",
"Karlskoga",
"orebro-lan"
],
[
"1884",
"Nora",
"orebro-lan"
],
[
"1885",
"Lindesberg",
"orebro-lan"
],
[
"1904",
"Skinnskatteberg",
"vastmanlands-lan"
],
[
"1907",
"Surahammar",
"vastmanlands-lan"
],
[
"1960",
"Kungsör",
"vastmanlands-lan"
],
[
"1961",
"Hallstahammar",
"vastmanlands-lan"
],
[
"1962",
"Norberg",
"vastmanlands-lan"
],
[
"1980",
"Västerås",
"vastmanlands-lan"
],
[
"1981",
"Sala",
"vastmanlands-lan"
],
[
"1982",
"Fagersta",
"vastmanlands-lan"
],
[
"1983",
"Köping",
"vastmanlands-lan"
],
[
"1984",
"Arboga",
"vastmanlands-lan"
],
[
"2021",
"Vansbro",
"dalarnas-lan"
],
[
"2023",
"Malung-Sälen",
"dalarnas-lan"
],
[
"2026",
"Gagnef",
"dalarnas-lan"
],
[
"2029",
"Leksand",
"dalarnas-lan"
],
[
"2031",
"Rättvik",
"dalarnas-lan"
],
[
"2034",
"Orsa",
"dalarnas-lan"
],
[
"2039",
"Älvdalen",
"dalarnas-lan"
],
[
"2061",
"Smedjebacken",
"dalarnas-lan"
],
[
"2062",
"Mora",
"dalarnas-lan"
],
[
"2080",
"Falun",
"dalarnas-lan"
],
[
"2081",
"Borlänge",
"dalarnas-lan"
],
[
"2082",
"Säter",
"dalarnas-lan"
],
[
"2083",
"Hedemora",
"dalarnas-lan"
],
[
"2084",
"Avesta",
"dalarnas-lan"
],
[
"2085",
"Ludvika",
"dalarnas-lan"
],
[
"2101",
"Ockelbo",
"gavleborgs-lan"
],
[
"2104",
"Hofors",
"gavleborgs-lan"
],
[
"2121",
"Ovanåker",
"gavleborgs-lan"
],
[
"2132",
"Nordanstig",
"gavleborgs-lan"
],
[
"2161",
"Ljusdal",
"gavleborgs-lan"
],
[
"2180",
"Gävle",
"gavleborgs-lan"
],
[
"2181",
"Sandviken",
"gavleborgs-lan"
],
[
"2182",
"Söderhamn",
"gavleborgs-lan"
],
[
"2183",
"Bollnäs",
"gavleborgs-lan"
],
[
"2184",
"Hudiksvall",
"gavleborgs-lan"
],
[
"2260",
"Ånge",
"vasternorrlands-lan"
],
[
"2262",
"Timrå",
"vasternorrlands-lan"
],
[
"2280",
"Härnösand",
"vasternorrlands-lan"
],
[
"2281",
"Sundsvall",
"vasternorrlands-lan"
],
[
"2282",
"Kramfors",
"vasternorrlands-lan"
],
[
"2283",
"Sollefteå",
"vasternorrlands-lan"
],
[
"2284",
"Örnsköldsvik",
"vasternorrlands-lan"
],
[
"2303",
"Ragunda",
"jamtlands-lan"
],
[
"2305",
"Bräcke",
"jamtlands-lan"
],
[
"2309",
"Krokom",
"jamtlands-lan"
],
[
"2313",
"Strömsund",
"jamtlands-lan"
],
[
"2321",
"Åre",
"jamtlands-lan"
],
[
"2326",
"Berg",
"jamtlands-lan"
],
[
"2361",
"Härjedalen",
"jamtlands-lan"
],
[
"2380",
"Östersund",
"jamtlands-lan"
],
[
"2401",
"Nordmaling",
"vasterbottens-lan"
],
[
"2403",
"Bjurholm",
"vasterbottens-lan"
],
[
"2404",
"Vindeln",
"vasterbottens-lan"
],
[
"2409",
"Robertsfors",
"vasterbottens-lan"
],
[
"2417",
"Norsjö",
"vasterbottens-lan"
],
[
"2418",
"Malå",
"vasterbottens-lan"
],
[
"2421",
"Storuman",
"vasterbottens-lan"
],
[
"2422",
"Sorsele",
"vasterbottens-lan"
],
[
"2425",
"Dorotea",
"vasterbottens-lan"
],
[
"2460",
"Vännäs",
"vasterbottens-lan"
],
[
"2462",
"Vilhelmina",
"vasterbottens-lan"
],
[
"2463",
"Åsele",
"vasterbottens-lan"
],
[
"2480",
"Umeå",
"vasterbottens-lan"
],
[
"2481",
"Lycksele",
"vasterbottens-lan"
],
[
"2482",
"Skellefteå",
"vasterbottens-lan"
],
[
"2505",
"Arvidsjaur",
"norrbottens-lan"
],
[
"2506",
"Arjeplog",
"norrbottens-lan"
],
[
"2510",
"Jokkmokk",
"norrbottens-lan"
],
[
"2513",
"Överkalix",
"norrbottens-lan"
],
[
"2514",
"Kalix",
"norrbottens-lan"
],
[
"2518",
"Övertorneå",
"norrbottens-lan"
],
[
"2521",
"Pajala",
"norrbottens-lan"
],
[
"2523",
"Gällivare",
"norrbottens-lan"
],
[
"2560",
"Älvsbyn",
"norrbottens-lan"
],
[
"2580",
"Luleå",
"norrbottens-lan"
],
[
"2581",
"Piteå",
"norrbottens-lan"
],
[
"2582",
"Boden",
"norrbottens-lan"
],
[
"2583",
"Haparanda",
"norrbottens-lan"
],
[
"2584",
"Kiruna",
"norrbottens-lan"
]
]